import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const countryImporterSelectors = importerSelectors(
  'country.importer',
)

export default countryImporterSelectors
